import { ArrowLeft, Home, SearchX } from 'lucide-react'
import { Link, useNavigate } from 'react-router'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <main className="flex min-h-screen items-center justify-center bg-surface px-5 py-12 text-center">
      <div className="w-full max-w-lg">
        <div className="mx-auto mb-7 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-50 text-primary-700">
          <SearchX size={30} aria-hidden="true" />
        </div>
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary-700">Errore 404</p>
        <h1 className="mb-4 text-3xl font-semibold tracking-tight text-heading sm:text-4xl">Questa pagina non esiste</h1>
        <p className="mx-auto mb-8 max-w-md text-base leading-7 text-muted">
          Il link potrebbe essere errato oppure la pagina è stata spostata. Controlla l’indirizzo o torna a una sezione valida.
        </p>
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-surface px-5 py-3 text-sm font-semibold text-heading transition-colors hover:bg-surface-subtle"
          >
            <ArrowLeft size={17} aria-hidden="true" /> Torna indietro
          </button>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary-700 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-800"
          >
            <Home size={17} aria-hidden="true" /> Vai alla dashboard
          </Link>
        </div>
        <p className="mt-10 text-xs text-muted">DomusAurea</p>
      </div>
    </main>
  )
}
